import React from 'react'
import Commoninformation from '../Pagehome/Commoninformation'
import { Link } from 'react-router-dom'
import Icons from '../../components/icons';

const Aboutus = () => {
    return (
        <>
            {/* <Commoninformation /> */}
            <div className='container-lg'>
                {/*breadcrunb start*/}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li><span><Icons.SlashSvg /></span></li>
                        <li className="breadcrumb-item active" aria-current="page">
                            About Us
                        </li>
                    </ol>
                </nav>
                {/*breadcrunb End*/}
            </div>
            <div className='innerpages-section padding-50'>
                <div className='container-lg'>

                    <div className='flex-box justify-center mb-4'>
                        <div className='custom-heading  text-center'>
                            About Us
                        </div>
                    </div>

                    <div className='inp-inner'>

                        <div className='custom-text ct-small'>
                            <strong>Welcome to Forbes</strong>, your premier destination for comprehensive updates, analysis, and stories from across the <strong>United Kingdom</strong>. Our goal is to provide <strong>accurate, reliable, and timely information</strong> that keeps readers informed and engaged.
                        </div>
                        <div className='custom-text ct-small'>
                            We feature coverage on <strong>business, finance, technology, lifestyle, culture, health, and entertainment</strong>, emphasizing developments in <strong>London, Birmingham, Manchester, Edinburgh, and other major UK regions</strong>. Each article undergoes thorough fact-checking to ensure clarity, credibility, and relevance.
                        </div>
                        <div className='custom-text ct-small'>
                            Our platform is built on principles of <strong>journalistic integrity, transparency, and impartial reporting</strong>. Readers can explore well-researched insights, diverse viewpoints, and authoritative content about matters impacting the UK.
                        </div>
                        <div className='custom-text ct-small'>
                            From breaking headlines to detailed analyses and feature stories, <strong>Forbes</strong> delivers informative, thought-provoking, and relevant content to individuals seeking trustworthy coverage.
                        </div>
                        <div className='custom-text ct-small aboutus-highlight'>
                            <strong>Stay informed. Gain knowledge. Experience the UK’s developments with</strong> <Link to="/" className="external-link">forbes.com</Link>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Aboutus